module.exports = __webpack_public_path__ + "img/Change Document.a54c8c02.svg";